import { bindActionCreators } from "redux";
import { call, put, take } from "redux-saga/effects";

import * as apiCaller from "../../api/apiCaller";

export const GET_LIST_CALLFLOW_NUMBER = "GET_LIST_CALLFLOW_NUMBER";
export const GET_LIST_CALLFLOW_NUMBER_ERROR = "GET_LIST_CALLFLOW_NUMBER_ERROR";
export const GET_LIST_CALLFLOW_NUMBER_SUCCESS =
  "GET_LIST_CALLFLOW_NUMBER_SUCCESS";

export const COUNT_LIST_CALLFLOW_NUMBER = "COUNT_LIST_CALLFLOW_NUMBER";
export const COUNT_LIST_CALLFLOW_NUMBER_ERROR =
  "COUNT_LIST_CALLFLOW_NUMBER_ERROR";
export const COUNT_LIST_CALLFLOW_NUMBER_SUCCESS =
  "COUNT_LIST_CALLFLOW_NUMBER_SUCCESS";

export const DELETE_CALLFLOW_NUMBER = "DELETE_CALLFLOW_NUMBER";
export const DELETE_CALLFLOW_NUMBER_ERROR = "DELETE_CALLFLOW_NUMBER_ERROR";
export const DELETE_CALLFLOW_NUMBER_SUCCESS = "DELETE_CALLFLOW_NUMBER_SUCCESS";

export const EDIT_CALLFLOW_NUMBER = "EDIT_CALLFLOW_NUMBER";
export const EDIT_CALLFLOW_NUMBER_SUCCESS = "EDIT_CALLFLOW_NUMBER_SUCCESS";
export const EDIT_CALLFLOW_NUMBER_ERROR = "EDIT_CALLFLOW_NUMBER_ERROR";

export const ADD_CALLFLOW_NUMBER = "ADD_CALLFLOW_NUMBER";
export const ADD_CALLFLOW_NUMBER_SUCCESS = "ADD_CALLFLOW_NUMBER_SUCCESS";
export const ADD_CALLFLOW_NUMBER_ERROR = "ADD_CALLFLOW_NUMBER_ERROR";
/**
 * Reducer
 */

const initialState = {
  callflowNumbers: [],
  callflowNumber: {},
  error: false,
  count: 0,
  loading: false,
};

export const callflowNumberReducer = (state = initialState, action) => {
  switch (action.type) {
    //get list
    case GET_LIST_CALLFLOW_NUMBER:
      return {
        ...state,
        loading: true,
      };
    case GET_LIST_CALLFLOW_NUMBER_SUCCESS:
      return {
        ...state,
        loading: false,
        callflowNumbers: action.payload,
      };
    case GET_LIST_CALLFLOW_NUMBER_ERROR:
      return {
        ...state,
        error: action.error,
        loading: true,
      };
    //count list
    case COUNT_LIST_CALLFLOW_NUMBER:
      return {
        ...state,
        loading: true,
      };
    case COUNT_LIST_CALLFLOW_NUMBER_SUCCESS:
      return {
        ...state,
        loading: false,
        count: action.payload,
      };
    case COUNT_LIST_CALLFLOW_NUMBER_ERROR:
      return {
        ...state,
        error: action.error,
        loading: true,
      };
    //delete list
    case DELETE_CALLFLOW_NUMBER:
      return {
        ...state,
      };
    case DELETE_CALLFLOW_NUMBER_SUCCESS:
      return {
        ...state,
        callflowNumber: action.payload,
      };
    case DELETE_CALLFLOW_NUMBER_ERROR:
      return {
        ...state,
        error: action.error,
      };
    //EDIT
    case EDIT_CALLFLOW_NUMBER:
      return {
        ...state,
      };
    case EDIT_CALLFLOW_NUMBER_SUCCESS:
      return {
        ...state,
        callflowNumber: action.payload,
      };
    case EDIT_CALLFLOW_NUMBER_ERROR:
      return {
        ...state,
        error: action.error,
      };
    //add
    case ADD_CALLFLOW_NUMBER:
      return {
        ...state,
      };
    case ADD_CALLFLOW_NUMBER_SUCCESS:
      return {
        ...state,
        callflowNumber: action.payload,
      };
    case ADD_CALLFLOW_NUMBER_ERROR:
      return {
        ...state,
        error: action.error,
      };
    default:
      return state;
  }
};

/**
 * Action
 */
export const getListCallflowNumber = (
  order,
  limit,
  skip,
  where,
  query = null
) => ({
  type: GET_LIST_CALLFLOW_NUMBER,
  data: {
    order,
    limit,
    skip,
    where,
    query,
  },
});

export const countListCallflowNumber = (where) => ({
  type: COUNT_LIST_CALLFLOW_NUMBER,
  data: {
    where,
  },
});

export const deleteCallflowNumber = (id) => ({
  type: DELETE_CALLFLOW_NUMBER,
  data: {
    id,
  },
});

export const editCallflowNumber = (
  id,
  title,
  actions,
  description,
  code,
  isActive
) => ({
  type: EDIT_CALLFLOW_NUMBER,
  data: {
    id,
    title,
    actions,
    description,
    code,
    isActive,
  },
});

export const addCallflowNumber = (
  title,
  actions,
  description,
  code,
  isActive
) => ({
  type: ADD_CALLFLOW_NUMBER,
  data: {
    title,
    actions,
    description,
    code,
    isActive,
  },
});

export const mapActionsToProps = (dispatch) => {
  return bindActionCreators(
    {
      getListCallflowNumber,
      deleteCallflowNumber,
      editCallflowNumber,
      addCallflowNumber,
      countListCallflowNumber,
    },
    dispatch
  );
};

/**
 * Apis
 */

const getListCallflowNumberApi = (order, limit, skip, where, query) => {
  return apiCaller.getLogs(
    "/cloud-pbx/time-work",
    { order, limit, skip, ...where },
    { ...query }
  );
};

const countListCallflowNumberApi = (where) => {
  return apiCaller.getData("/cloud-pbx/time-work/count", { ...where });
};

const deleteCallflowNumberApi = (id) => {
  return apiCaller.del(`/cloud-pbx/time-work/${id}`);
};

const addCallflowNumberApi = (title, actions, description, code, isActive) => {
  return apiCaller.post("/cloud-pbx/time-work", {
    title,
    actions,
    description,
    code,
    isActive,
  });
};

const editCallflowNumberApi = (
  id,
  title,
  actions,
  description,
  code,
  isActive
) => {
  return apiCaller.put(`/cloud-pbx/time-work/${id}`, {
    title,
    actions,
    description,
    code,
    isActive,
  });
};

/**
 * sagas
 */

export const getListCallflowNumberFlow = function* () {
  while (true) {
    const action = yield take(GET_LIST_CALLFLOW_NUMBER);
    try {
      const res = yield call(
        getListCallflowNumberApi,
        action.data.order,
        action.data.limit,
        action.data.skip,
        action.data.where,
        action.data.query
      );
      yield put({ type: GET_LIST_CALLFLOW_NUMBER_SUCCESS, payload: res.data });
    } catch (error) {
      yield put({ type: GET_LIST_CALLFLOW_NUMBER_ERROR, error });
    }
  }
};

export const deleteCallflowNumberFlow = function* () {
  while (true) {
    const action = yield take(DELETE_CALLFLOW_NUMBER);
    try {
      const res = yield call(deleteCallflowNumberApi, action.data.id);
      yield put({ type: DELETE_CALLFLOW_NUMBER_SUCCESS, payload: res.data });
    } catch (error) {
      yield put({ type: DELETE_CALLFLOW_NUMBER_ERROR, error });
    }
  }
};
export const editCallflowNumberFlow = function* () {
  while (true) {
    const action = yield take(EDIT_CALLFLOW_NUMBER);
    try {
      const res = yield call(
        editCallflowNumberApi,
        action.data.id,
        action.data.title,
        action.data.actions,
        action.data.description,
        action.data.code,
        action.data.isActive
      );
      yield put({ type: EDIT_CALLFLOW_NUMBER_SUCCESS, payload: res.data });
    } catch (error) {
      yield put({ type: EDIT_CALLFLOW_NUMBER_ERROR, error });
    }
  }
};
export const addCallflowNumberFlow = function* () {
  while (true) {
    const action = yield take(ADD_CALLFLOW_NUMBER);
    try {
      const res = yield call(
        addCallflowNumberApi,
        action.data.title,
        action.data.actions,
        action.data.description,
        action.data.code,
        action.data.isActive
      );
      yield put({ type: ADD_CALLFLOW_NUMBER_SUCCESS, payload: res.data });
    } catch (error) {
      yield put({ type: ADD_CALLFLOW_NUMBER_ERROR, error });
    }
  }
};

export const countCallflowNumberFlow = function* () {
  while (true) {
    const action = yield take(COUNT_LIST_CALLFLOW_NUMBER);
    try {
      const res = yield call(countListCallflowNumberApi, action.data.where);
      yield put({
        type: COUNT_LIST_CALLFLOW_NUMBER_SUCCESS,
        payload: res.data,
      });
    } catch (error) {
      yield put({ type: COUNT_LIST_CALLFLOW_NUMBER_ERROR, error });
    }
  }
};
